import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=31d3a39d&scoped=true"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"
import style0 from "./changePwd.vue?vue&type=style&index=0&id=31d3a39d&lang=scss"
import style1 from "./changePwd.vue?vue&type=style&index=1&id=31d3a39d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3a39d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d3a39d')) {
      api.createRecord('31d3a39d', component.options)
    } else {
      api.reload('31d3a39d', component.options)
    }
    module.hot.accept("./changePwd.vue?vue&type=template&id=31d3a39d&scoped=true", function () {
      api.rerender('31d3a39d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/changePwd.vue"
export default component.exports